/** @format */
export var smallBreak = 783;
export var wideBreak = 1365;
//# sourceMappingURL=breakpoints.js.map